import { FetchRequestError } from "./FetchRequestError";

export class FetchServerError extends FetchRequestError {}
